import { createUseI18n } from "keycloakify/login"

export const { useI18n } = createUseI18n({
    // NOTE: Here you can override the default i18n messages
    // or define new ones that, for example, you would have
    // defined in the Keycloak admin UI for UserProfile
    // https://user-images.githubusercontent.com/6702424/182050652-522b6fe6-8ee5-49df-aca3-dba2d33f24a5.png
    en: {
        alphanumericalCharsOnly: "Only alphanumerical characters",
        // Here we overwrite the default english value for the message "doForgotPassword"
        // that is "Forgot Password?" see: https://github.com/InseeFrLab/keycloakify/blob/f0ae5ea908e0aa42391af323b6d5e2fd371af851/src/lib/i18n/generated_messages/18.0.1/login/en.ts#L17
        doForgotPassword: "Forgot password?",
        invalidUserMessage: "Invalid username or password.",
        termsAcceptanceRequired: "You must agree to our terms and conditions.",
        acceptTerms: "I agree to the terms and conditions.",
        loginTotpReason:
            "Two-Factor Authentication (2FA) adds an extra layer of security, making it harder for unauthorised individuals to gain access to your account.",
        loginTotpDescription:
            "Retrieve your one-time code from the authenticator mobile app (e.g., Google Authenticator or Microsoft Authenticator) used during registration.",
        accountManagementWelcomeMessage:
            "Welcome to SMDH SSO Account Management",
        authenticatorChoiceFormNewUserPrompt: "You need to set up at least one Authenticator to activate your account.",
        authenticatorChoiceFormExistingUserPrompt: "You can now set up passwordless authentication to simplify your login experience.",
        webauthnPasswordlessDescrption:
            "Passwordless authentication lets you access your account easily and securely without a password, using methods like fingerprint, facial recognition, or a PIN. It offers a quicker, safer login, reducing the risk of password theft. ",
        webAuthnCheckboxLabel: "WebAuthn Passwordless",
        webAuthnCheckboxDescription:
            "Use a security key or biometric authenticator to sign in faster and more securely.",
        webAuthnCheckboxLink: "Learn more",
        otpCheckboxLabel: "One Time Password (OTP)",
        otpCheckboxDescription: "Use a one-time code to sign in.",
        otpCheckboxLink: "Learn more",
        webauthnRegistrationTitle: "Security Key Registration",
        loginOtpOneTime: "One-time code from your device",

        // loginTitle: "SMDH SSO"
    },
})

export type I18n = NonNullable<ReturnType<typeof useI18n>>
